import { cn } from "@/lib/utils";

type CardProps = {
    children: React.ReactNode;
    className?: string;
};

const Card: React.FC<CardProps> = ({ children, className }) => {
    return (
        <div
            className={cn(
                "flex w-full flex-col bg-whiteShade-20",
                "gap-[8px] rounded-[10px] px-[24px] py-[18px] shadow-chatBubble-innerShadow-mobile backdrop-blur-[52px]",
                "2xs:gap-[10px]",
                "md:px-[38px] md:py-[28px]",
                "lg:rounded-[16px] lg:shadow-chatBubble-innerShadow-mobile lg:backdrop-blur-[80px]",
                "4k:rounded-[64px] 4k:py-[128px] 4k:px-[168px] 4k:gap-[48px]",
                className,
            )}
        >
            {children}
        </div>
    );
};

export default Card;
